// TODO: Lodash should no longer be used here
// eslint-disable-next-line no-restricted-imports
import _ from 'lodash';
import { LOCATIONS_FETCHED, LOCATION_SELECTED, LOCATION_SELECTION_CLEARED, LOCATION_UPDATED } from '../actions/types';

export type LocationsReducerState = {
  selectedLocation: {
    id?: string;
  };
  count: number;
  list: {
    id: string;
  }[];
  /**
   * True once a fetch has returned, so callers can tell "still loading" from "this organization
   * genuinely has no locations" — both of which otherwise look like an empty `list`. Anything
   * deriving a timezone from a location needs the distinction; see useInitialTransactionFilters.
   */
  isLoaded: boolean;
};
const initialState: LocationsReducerState = {
  selectedLocation: {},
  count: 0,
  list: [],
  isLoaded: false,
};

const locations = (state = initialState, action) => {
  switch (action.type) {
    case LOCATIONS_FETCHED: {
      const list = action.locations.list.filter((location) => location?.isArchived !== true);

      return {
        ...state,
        count: action.locations.count,
        list,
        isLoaded: true,
      };
    }
    case LOCATION_SELECTED: {
      return { ...state, selectedLocation: action.location };
    }
    // Replace selected with the newly updated data.
    // New data is fetched by the listener as soon as listener receives the update.
    case LOCATION_UPDATED: {
      return {
        ...state,
        selectedLocation: _.find(state.list, { id: state.selectedLocation.id }),
      };
    }
    case LOCATION_SELECTION_CLEARED: {
      return { ...state, selectedLocation: {} };
    }

    default: {
      return state;
    }
  }
};

export default locations;
